import { render, staticRenderFns } from "./DepositOrderSummons.vue?vue&type=template&id=dbb5deb0&scoped=true&"
import script from "./DepositOrderSummons.vue?vue&type=script&lang=js&"
export * from "./DepositOrderSummons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb5deb0",
  null
  
)

export default component.exports